/* eslint-disable no-inner-declarations */
/**
* @name planning
* @autor over.martinez@u-planner.com
* @description : Pool of commons functions to help development
* # planning
* @name factory: Helpers
*/

class Helpers {
	
	constructor(SERVICE_URL_CONSTANT, $filter, $http, ngNotify, $mdDialog, LOCAL_ENV_CONSTANT, $cookies, $localStorage, moment, $timeout) {
		this.$translate = $filter('translate')
		this.inputsArray = [ 'multipleSelect', 'multipleSelectSuggest', 'listGroup', 'table', 'file', 'structure', 'concatFields' ]
		this.inputsInLine = [ 'text', 'number', 'textArea', 'switch', 'datetime', 'checkbox' ]
		this.inputsObject = [ 'select', 'selectSuggest', 'datetimeRange' ]
		this.typefieldsNotEvaluate = [ 'ui-grid', 'history' ]
		this.$localStorage = $localStorage
		this.inputs = this.inputsInLine.concat(this.inputsObject, this.inputsArray)
		this.systemConfig = LOCAL_ENV_CONSTANT
		this.clt = {
			error: {
				default: { title: ' Unknow error!', message: 'No Description' }, 
				title  : 'consoleLogTitleErrorStyle',
				subT   : 'consoleLogSubtitleErrorStyle',
			},
			warn: {
				default: { title: ' Unknow warning!', message: 'No Description' }, 
				title  : 'consoleLogTitleWarnStyle',
				subT   : 'consoleLogSubtitleWarnStyle',
			},
			info: {
				default: { title: ' Info!', message: 'No Description' }, 
				title  : 'consoleLogTitleInfoStyle',
				subT   : 'consoleLogSubtitleInfoStyle',
			},
		}
		let commonsStyle = [
			'display: block',
			'font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
			'font-style: bold',
			'font-weight: 400',
			'line-height: 1.42857142857143',
			'letter-spacing: -.005em',
		]

		this.consoleLogTitleErrorStyle = commonsStyle.concat([ 'font-size: 24px', 'color: red' ]).join(';')
		this.consoleLogSubtitleErrorStyle = commonsStyle.concat([ 'font-size: 14px', 'color: red' ]).join(';')
		this.consoleLogTitleWarnStyle = commonsStyle.concat([ 'font-size: 24px', 'color: orange' ]).join(';')
		this.consoleLogSubtitleWarnStyle = commonsStyle.concat([ 'font-size: 14px', 'color: orange' ]).join(';')
		this.consoleLogTitleInfoStyle = commonsStyle.concat([ 'font-size: 24px', 'color: blue' ]).join(';')
		this.consoleLogSubtitleInfoStyle = commonsStyle.concat([ 'font-size: 14px', 'color: blue' ]).join(';')
		/**
		* Funcion para validar estructuras de arbol como la del syllabus
		**/
		this.checkStructureInputsRequire = (structure, errors, parent) => {
			structure = structure || []
			errors = errors || { status: true }
			parent = parent || 'MAIN_ACCORDION'
			errors[parent] = { errors: [] }

			for (let i in structure) {
				if (this.inputs.indexOf(structure[i].typefield) >= 0) {
					if (structure[i].isRequired == 1) {
						if (this.inputsArray.indexOf(structure[i].typefield) >= 0) {
							/**
							* Validando los campos de tipo arreglo como ['multipleSelect', 'multipleSelectSuggest', 'listGroup']
							**/
							if (structure[i].data.length <= 0 || angular.equals(structure[i].data[0], {})) {
								errors.status = false
								errors[parent].errors.push({
									label: this.$translate(structure[i].label),
									text : 'Es requerido',
								})
							}
						} else if (this.inputsObject.indexOf(structure[i].typefield) >= 0) {
							/**
							* Validando los campos de tipo Object como ['select', 'selectSuggest', 'datetimeRange']
							**/
							if (Object.keys(structure[i].data).length <= 0) {
								errors.status = false
								errors[parent].errors.push({
									label: this.$translate(structure[i].label),
									text : 'Es requerido',
								})
							}
						} else {
							/**
							* Validando los campos lineales como ['text', 'number', 'textArea', 'switch', 'datetime']
							**/
							// structure[i].data[0] = structure[i].data[0] || {}
							if (!structure[i].data[0] || structure[i].data[0].value === undefined || structure[i].data[0].value === null || structure[i].data[0].value === '') {
								errors.status = false
								errors[parent].errors.push({
									label: this.$translate(structure[i].label),
									text : 'Es requerido',
								})
							}
						}
					}
				} else if (this.typefieldsNotEvaluate.indexOf(structure[i].typefield) >= 0) {
					errors[parent].errors = errors[parent].errors || []
				} else {
					/**
					* Validacion recursiva
					**/
					let err = this.checkStructureInputsRequire(structure[i].data, errors, structure[i].label)

					errors[parent][structure[i].label] = err.errors
					errors.status = err.status
				}
			}

			return { errors: errors[parent], status: errors.status }
		}

		/**
		* Funcion generica para obtener los parametros para los servicios de listado de los dynamic-inputs
		**/
		this.getParam = (model, paramName, config) => {
			let p = {}

			if (Array.isArray(model)) {
				p[paramName] = model.map(item => {
					return item[config.id]
				})
			} else if (typeof model == 'object') {
				if (model[config.id]) {
					p[paramName] = model[config.id]
				}
			} else {
				p[paramName] = model
			}

			return p
		}

		this.chunkData = (arrayList, limit) => {
			limit = limit || 2
			let chunk = {}
			let x = 0
			let cols = 0

			arrayList.data.forEach((sec) => {
				cols += sec.col || ((typeof sec.cols == 'string') ? parseInt(sec.cols) : null) || 1

				if (cols > limit) {
					cols = sec.col || ((typeof sec.cols == 'string') ? parseInt(sec.cols) : null) || 1
					x++
				}

				chunk[x] = chunk[x] || []
				chunk[x].push(sec)
			})

			return Object.values(chunk)
		}
	
		this.defineStructure = (section, order) => {
			if (!section) { return false }

			/**
			* Otros tipos de orden
			*  first | last | first-last | full | none
			**/
			order = order || 'first-last'
			let isPar = (section.data.length % 2) == 0 ? 1 : 2

			section.data = section.data.sort((a, b) => a.orderBy - b.orderBy)
			for (let i in section.data) {
				if (order == 'first-last') {
					if (i == 0 || i == (section.data.length - 1)) {
						section.data[i].col = 2
						continue
					}
 
					section.data[i].col = isPar != 0 ? isPar : 1
					isPar = 0
				} else if (order == 'full') {
					section.data[i].col = 2
				} else if (order == 'first') {
					if (i == 0) {
						section.data[i].col = 2
						continue	
					}

					section.data[i].col = isPar != 0 ? isPar : 1
					isPar = 0
				} else if (order == 'last') {
					if (i == (section.data.length - 1)) {
						section.data[i].col = 2
						continue
					}

					section.data[i].col = isPar != 0 ? isPar : 1
					isPar = 0
				} else if (order == 'none') {
					section.data[i].col = 1
				}
			}
			section.data = this.chunkData(section)

			section.data.forEach((row) => {
				row.forEach((panel) => {
					if (panel.typefield == 'panel') {
						panel.data = this.definePanel(panel)
					} else if (panel.typefield == 'dynamicOccurrences') {
						panel.data.forEach((ocurrency) => {
							ocurrency.data = this.definePanel(ocurrency, true)
						})
					} else if (panel.typefield == 'occurrences') {
						panel.data.forEach((ocurrency) => {
							ocurrency.col = panel.col
							ocurrency.data = this.definePanel(ocurrency)
						})
					}
				})
			})

			return section
		}

		this.definePanel = (panel, isOcur) => {
			let items = panel.data.length

			panel.data = panel.data.sort((a, b) => a.orderBy - b.orderBy)
			panel.data.forEach((field) => {
				field.col = ((panel.col == 2 && items > 1)) ? 1 : 2
				field.col = (isOcur) ? 1 : field.col

				if ([ 'occurrences', 'dynamicOccurrences' ].indexOf(field.typefield) >= 0) {
					field.data = field.data || []
					// eslint-disable-next-line no-unused-vars
					field.data.forEach((acco) => {
						acco = this.defineStructure(acco, 'none')
					})
				}
			})

			panel.data = this.chunkData(panel)

			return panel.data
		}

		this.getItemForModel = (field, data = {}, conf) => {
			conf = conf || { name: 'ds_name', id: 'id_code', code: 'ds_code' }
			let namesForName = [ 'componentName', 'courseName', 'equivalenceName', 'activityName', 'cycleName', 'studentName', 'campusPeriodShiftName', 'roleName', 'workflowName', 'statusName', 'value', 'adminitstrativeName', 'teacherName', 'ModalityName', 'languajeName', 'name', 'academicPeriodName', 'periodName', 'careerName', 'pensumName', 'campusName', 'facultyName', 'periodTypeName', 'shiftName', 'departmentName', 'userName', 'resourceTypeName', 'usageTypesName' ]
			let namesForCode = [ 'componentCode', 'courseCode', 'equivalenceCode', 'activityCode', 'cycleCode', 'studentCode', 'campusPeriodShiftCode', 'roleCode', 'workflowCode', 'statusCode', 'academicPeriodCode', 'periodCode', 'pensumCode', 'careerCode', 'campusCode', 'facultyCode', 'periodTypeCode', 'shiftCode', 'departmentCode', 'teacherCode', 'userCode', 'resourceTypeCode', 'usageTypesCode' ]
			let namesForId = [ 'componentId', 'courseId', 'equivalenceId', 'activityId', 'cycleId', 'studentId', 'campusPeriodShiftId', 'roleId', 'workflowId', 'statusId', 'id', 'idAdministrative', 'teacherId', 'modalityId', 'languajeId', 'academicPeriodId', 'periodId', 'pensumId', 'careerId', 'campusId', 'periodTypeId', 'shiftId', 'departmentId', 'teacherId', 'userId', 'resourceTypeId', 'usageTypesId' ]
			let localField = null
			let item = {}

			if (data.studentFirstName || data.studentLastName) {
				data.studentName = this.getTitle(data, 'studentFirstName', 'studentLastName', ' ')
			}

			for (let f in data) {
				let fi = (namesForName.indexOf(f) >= 0) ? (item[conf.name] ? f : conf.name) : f
				let fie = (namesForCode.indexOf(fi) >= 0) ? (item[conf.code] ? fi : conf.code) : fi

				localField = (namesForId.indexOf(fie) >= 0) ? (item[conf.id] ? fie : conf.id) : fie
				item[localField] = data[f]
				item[f] = data[f]
			}
			delete item.value
			delete item.id
			field.addParams = field.addParams || {}

			if (Object.keys(field.addParams).length > 0) {
				for (let i in field.params) {
					item[field.params[i]] = field.addParams[field.params[i]]
				}
			}

			return _.size(item) > 1 ? item : null
		}

		this.organizeElements = (section, order) => {
			if (!section) return false

			section.data = section.data || []

			if (Array.isArray(section.data[0])) {
				return section
			}

			/**
			* Otros tipos de orden
			*  first | last | first-last | full | none
			**/
			order = order || 'first-last'
			section.data = section.data.sort((a, b) => a.orderBy - b.orderBy)

			for (let i in section.data) {
				if (order == 'first-last') {
					section.data[i].col = 1

					if (i == 0 || i == (section.data.length - 1)) {
						section.data[i].col = 2
					}
				} else if (order == 'full') {
					section.data[i].col = 2
				} else if (order == 'first') {
					section.data[i].col = 1

					if (i == 0) {
						section.data[i].col = 2
					}
				} else if (order == 'last') {
					if (i == (section.data.length - 1)) {
						section.data[i].col = 2
					} else {
						section.data[i].col = 1
					}
				} else if (order == 'none') {
					section.data[i].col = 1
				}
			}

			section.data = this.chunkData(section)

			return section
		}

		this.saveChanges = (opt, params, callback, noMessage) => {
			callback = callback || (() => {})
			$http({
				url   : opt.url,
				method: opt.method || 'POST',
				data  : params,
			}).then((response) => {
				if (response.data.status) {
					if (!noMessage) {
						ngNotify.set(this.$translate('UPDATE_SUCCESS_MESSAGE'), 'success')
					}

					callback(true, response.data)
				} else {
					callback(response.data)

					if (!noMessage) {
						ngNotify.set('Ocurrio un error con el servicio', 'error')
					}
				}
			}, () => {
				callback(false)

				if (!noMessage) {
					ngNotify.set('Imposible conectar con el servicio ' + opt.url, 'error')
				}
			})
		}
	
		this.validateRequiredInputs = (data, forcedInputs) => {
			for (let i in forcedInputs) {
				if (data[forcedInputs[i]] == undefined) {
					ngNotify.set('Falta completar campos obligatorios', 'warn')

					return false
				}
			}

			return true
		}

		this.consoleLog = (msg, type, trace) => {
			type = type || 'error' // [error | warn | info]
			let standardTitle = 'Sandbox-front | '

			if (Array.isArray(msg)) {
				// Comming soon
			} else if (typeof msg == 'object') {
				msg = angular.extend({}, this.clt[type].default, msg)
			} else {
				msg = { title: msg, message: this.clt[type].default.message }
			}

			// eslint-disable-next-line no-console
			console.log('%c ' + standardTitle + msg.title, this[this.clt[type].title])
			// eslint-disable-next-line no-console
			console.log('%c Description: ' + msg.message, this[this.clt[type].subT])
			
			if (trace) {
				// eslint-disable-next-line no-console
				console.trace('%c Sequency functions calls', this.consoleLogSubtitleErrorStyle)
			}
		}

		this.getListByConcept = (concept, callback) => {
			callback = callback || (() => {})
			let url = SERVICE_URL_CONSTANT.improve + '/commons/getList'

			if (concept) {
				$http({
					url   : url,
					method: 'GET',
					params: { concept: concept },
				}).then((response) => {
					if (response.data.status) {
						callback(response.data)
					} else {
						callback(false)
						let error = {
							title  : 'Helper Error Message: getListByConcept',
							message: response.data.message || 'Ocurrio un error en el servicio ' + url,
						}

						this.consoleLog(error)
					}
				}, () => {
					callback(false)
					let err = {
						title  : 'Helper Error Message: getListByConcept',
						message: 'Imposible conectar con el servicio ' + url,
					}

					this.consoleLog(err)
				})
			} else {
				callback(false)
				let error = {
					title  : 'Helper Error Message: getListByConcept',
					message: "No se recibio el valor del parametro 'concept'",
				}

				this.consoleLog(error)
			}
		}

		this.checkCode = (publicId, concept, idCode, callback) => {
			callback = callback || (() => {})
			idCode = idCode || 0
			let params = { publicId: publicId, concept: concept, idCode: idCode }
			let url = SERVICE_URL_CONSTANT.coreApi + '/helpers/checkPID'

			if (concept && publicId) {
				$http({
					url   : url,
					method: 'GET',
					params: params,
				}).then((response) => {
					if (response.data.status) {
						let valid = true

						if (response.data.data.length > 0) {
							valid = false
						}

						callback(valid)
					} else {
						callback(false)
						ngNotify.set('Ocurrio un error con el servicio', 'warn')
						let error = {
							title  : 'Helper Error Message: checkCode',
							message: response.data.message || 'Ocurrio un error en el servicio ' + url,
						}

						this.consoleLog(error)
					}
				}, () => {
					callback(false)
					ngNotify.set('Imposible conectar con el servicio ' + url, 'warn')
					let err = {
						title  : 'Helper Error Message: checkCode',
						message: 'Imposible conectar con el servicio ' + url,
					}

					this.consoleLog(err)
				})
			} else {
				callback(false)
				ngNotify.set('Ver consola ', 'warn')
				let error = {
					title  : 'Helper Error Message: checkCode',
					message: 'Error en el envio de parametros (publicId, concept, idCode)',
				}

				this.consoleLog(error)
			}
		}

		this.guid = (segmentCounts) => {
			segmentCounts = segmentCounts || 3
			let segments = []

			segments.push(s4() + s4())
			function s4() {
				return Math.floor((1 + Math.random()) * 0x10000)
					.toString(16)
					.substring(1)
			}
			for (var i = 0; i < segmentCounts; i++) {
				segments.push(s4())
			}
			segments.push(s4() + s4() + s4())

			return segments.join('-')
		}

		this.getGridConfig = (options) => {
			let defaultOpt = {
				exporterMenuCsv    : true,
				exporterMenuPdf    : false,
				exporterCsvFilename: 'uiGridTable.csv',
				enableGridMenu     : true,
				enableFiltering    : true,
				enablePaging       : true,
				paginationPageSizes: [ 25, 50, 100, 200, 500, 10000 ],
				paginationPageSize : 25,
				columnDefs         : [],
			}

			return angular.extend({}, defaultOpt, options)
		}

		this.getFieldData = (field) => {
			if (this.inputsArray.indexOf(field.typefield) >= 0) {
				let model = []

				if (field.model) {
					field.model.forEach((item) => {
						if (item.model) {
							model.push({ id: item.model.id_code, value: item.model.ds_name })
						}
					})
				}

				return model
			} else if (this.inputsObject.indexOf(field.typefield) >= 0) {
				if (field.model) {
					return [ { id: field.model.id_code, value: field.model.ds_name } ]
				} else {
					return []
				}
			} else if (this.inputsInLine.indexOf(field.typefield) >= 0) {
				return [ { value: field.model } ]
			}

			return []
		}

		// this.mathjs = require('../../../bower_components/mathjs/dist/math.min.js')

		this.findFunction = (formula) => {
			const functionsList = [ 'MejorX', 'PeorX', 'Mejor', 'Peor', 'Promedio', 'IF' ]
			var _this = this

			function containsFunctions(str) {
				var functions = [ 'Mejor', 'Peor', 'Promedio', 'IF' ]

				for (var i = 0; i != functions.length; i++) {
					let fn = functions[i]

					if (str.toString().indexOf(fn) != - 1) {
						return true
					}
				}

				return false 
			}
			// eslint-disable-next-line no-unused-vars
			function Promedio() {
				let count = arguments.length

				if (count) {
					let compare = []

					for (let arg of arguments) {
						compare.push(arg)
					}
					const exec = '(' + compare.join('+') + ')/' + count

					return eval(exec)
				} else {
					return 0
				}
			}
			// eslint-disable-next-line no-unused-vars
			function IF(condition, thenVal, elseVal) {
				if (eval(condition)) {
					return _this.findFunction(thenVal)
				} else {
					return _this.findFunction(elseVal)
				}
			}
			// eslint-disable-next-line no-unused-vars
			function Mejor() {
				let compare = []

				for (let arg of arguments) {
					compare.push(arg)
				}

				compare.sort()
				compare.reverse()

				return compare[0]
			}
			// eslint-disable-next-line no-unused-vars
			function Peor() {
				let compare = []

				for (let arg of arguments) {
					compare.push(arg)
				}
				compare.sort()

				return compare[0]
			}
			// eslint-disable-next-line no-unused-vars
			function MejorX() {
				let compare = []
				const count = arguments[0]

				if (count) {
					for (let i in arguments) {
						if (i > 0) {
							compare.push(arguments[i])
						}
					}
					compare.sort()
					compare.reverse()
					let response = []

					for (let i = 0 ; i < count; i++) {
						response.push(compare[i])
					}

					return response
				} else {
					return 0
				}
			}
			// eslint-disable-next-line no-unused-vars
			function PeorX() {
				let compare = []
				const count = arguments[0]

				if (count) {
					for (let i in arguments) {
						if (i > 0) {
							compare.push(arguments[i])
						}
					}
					compare.sort()
					let response = []

					for (let i = 0 ; i < count; i++) {
						response.push(compare[i])
					}

					return response
				} else {
					return 0
				}
			}

			function findFN(formula, str) {
				let re = new RegExp(str + '\\(([^()]+)\\)', 'g')
				let res = res = formula.toString().match(re)

				formula = (formula === undefined || formula === null) ? '' : formula

				if (res) {
					for (let i in res) {
						if (res[i] == (res[i].match(re))[0]) {
							let fn = (str + (res[i].match(/\([^()]+\)/g))[0])

							res[i] = eval(fn)
						} else {
							res[i] = _this.findFunction(res[i])
						}
					}
					for (let i in res) {
						formula = formula.replace(((formula.toString().match(re))[0]), res[i])
					}
				} else {
					if (containsFunctions(formula) <= 1) {
						let re = new RegExp('\\(([^()]+)\\)', 'g')
						let res = formula.toString().match(re)

						if (res) {
							let orig = angular.copy(res)

							for (let i in res) {
								if (res[i].toString().indexOf(',') >= 0) continue

								// res[i] = _this.mathjs.eval(res[i])
							}
							for (let i in res) {
								formula = formula.replace(orig[i], res[i])
							}
						}
					}
				}

				return formula
			}
			
			for (let fun of functionsList) {
				formula = findFN(formula, fun)
			}
			while (containsFunctions(formula)) {
				formula = _this.findFunction(formula)
			}

			return formula
		}

		this.getRandomClassColor = (noneOf) => {
			noneOf = noneOf || []
			const colorNames = [ 'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange' ] //, 'deep-orange', 'brown', 'blue-grey', 'grey']
			// eslint-disable-next-line no-unused-vars
			const tonality = [ 'A100', 'A200', 'A400', 'A700' ]
			// let tonalityIndex = Math.floor((Math.random() * tonality.length))
			let colorIndex = null

			if (noneOf.length >= colorNames.length) {
				noneOf = []
			}

			do {
				colorIndex = Math.floor((Math.random() * colorNames.length))
			} while (noneOf.indexOf(colorNames[colorIndex]) >= 0)

			return colorNames[colorIndex] // + '-' + tonality[tonalityIndex]
		}

		this.getHeaderCellTemplate = (header) => {
			header = header || 'tooltip'

			if (header == 'tooltip') {
				return require('./templates/headerUiGridTooltipTemplate.html')
			} else {
				this.consoleLog('getHeaderCellTemplate => header "' + header + '" is not defined')
			}
		}

		this.getTitle = (obj, code, name, split) => {
			obj = obj || {}
			split = split || ' - '
			let t = [ obj[code], obj[name] ]
			let title = t.filter(a => {return ((a && a != 0) || a == '0') ? true : false }).join(split)

			return title
		}

		this.getWeekDays = (day) => {
			let weekDays = [
				{ day: 1, name: 'MON' },
				{ day: 2, name: 'TUE' },
				{ day: 3, name: 'WED' },
				{ day: 4, name: 'THU' },
				{ day: 5, name: 'FRI' },
				{ day: 6, name: 'SAT' },
				{ day: 7, name: 'SUN' },
			]

			if (day) {
				return weekDays[parseInt(day) - 1]
			} else {
				return weekDays
			}
		}

		this.prepareCourseList = (data) => {
			let response = []

			data = data || []
			data.forEach((course) => {
				const subt = this.getTitle(course, 'departmentCode', 'departmentName')
				const desc = this.getTitle(course, 'facultyCode', 'facultyName')

				response.push(angular.extend({}, course, {
					id_code        : course.courseId, 
					cod            : course.courseCode,
					title          : course.courseName,
					subTitle       : subt, 
					descriptionList: [
						{ label: 'FACULTY', value: desc },
						{ label: 'DEPARTMENT', value: subt },
					],
					badges: [ { bg: 'bg-warning', label: course.statusName } ],
				}))
			})

			return response
		}

		this.prepareSectionList = (Data) => {
			let response = []

			Data = Data || []
			for (let section of Data) {
				section.roles = section.roles || []
				section.roles = section.roles || []
				section.courses = section.courses || []
				section.teachers = section.teachers || []
				let teachers = section.teachers.filter(teach => teach.isPrincipal).map(teach => teach.teacherName)

				section.activities = section.activities || []
				let activities = section.activities.map(act => this.getTitle(act, 'activityCode', 'activityName'))
				let item = angular.extend({}, section, {
					id_code        : section.sectionId, 
					title          : section.courses.map(course => (this.getTitle(course, 'courseCode', 'courseName'))),
					descriptionList: [
						{ label: (teachers.length ? 'IMPROVE_PROFESSOR' : false), value: teachers.join() },
						{ label: 'SECTION', value: section.sectionName },
						{ label: 'NRC', value: section.sectionNumber },
						{ label: (activities.length ? 'ACTIVITY' : false), value: activities.join(', ') },
						{ label: 'PERIOD', value: this.getTitle(section, 'periodCode', 'periodName') },
					],
					rolLabels: section.roles.map(role => ({
						id     : role.roleId,
						id_code: role.roleCode, 
						ds_name: role.roleName,
					})),
					badges: [
						{ bg: 'bg-warning', label: section.statusName },
						{ bg: 'bg-info', label: (section.evaluationAssigned ? 'ASIGNED' : false), icon: 'fal fa-check no-margin' },
						{ bg: 'bg-info', label: (section.inProgress == 1 ? 'COURSE_IN_PROGRESS' : false), icon: 'fal fa-chalkboard-teacher no-margin' },
					],
				})

				response.push(item)
			}

			return response
		}

		this.filterInObject = (obj, text) => {
			let search = new RegExp(text, 'gi')

			for (let i in obj) {
				if (obj[i].toString().match(search)) {
					return true
				}
			}

			return false
		}

		this.getName = (ar) => {
			let ext = ar[ar.length - 1].toLowerCase()

			return ar.filter(i => i.toLowerCase() !== ext).join('.')
		}

		this.getFileIcon = (file) => {
			let classes = {
				w : 'fal fa-file-word',
				p : 'fal fa-file-pdf',
				pp: 'fal fa-file-powerpoint',
				x : 'fal fa-file-excel',
				c : 'fal fa-file-csv',
				t : 'fal fa-file-alt',
				o : 'fal fa-file',
				i : 'fal fa-file-image',
				v : 'fal fa-file-video',
			}

			file.filename = file.filename || file.fileName || ''
			let limitTo = 10
			const fn = file.filename.toString().split('.')

			file.showName = this.getName(fn)
			file.showName = $filter('limitTo')(file.showName, limitTo) + (file.showName.length >= limitTo ? '...' : '.') + (fn[fn.length - 1] || '')
			let ext = fn[fn.length - 1] ? fn[fn.length - 1].toLowerCase() : 'o'

			if ([ 'doc', 'docx' ].indexOf(ext) >= 0) {
				return classes['w']
			}

			if ([ 'pdf' ].indexOf(ext) >= 0) {
				return classes['p']
			}

			if ([ 'ppt', 'pptx', 'pptm' ].indexOf(ext) >= 0) {
				return classes['pp']
			}

			if ([ 'csv' ].indexOf(ext) >= 0) {
				return classes['c']
			}

			if ([ 'xls', 'xlsx' ].indexOf(ext) >= 0) {
				return classes['x']
			}

			if ([ 'txt' ].indexOf(ext) >= 0) {
				return classes['t']
			}

			if ([ 'mp4', 'mov', 'avi', 'mkv', 'flv', 'swf', 'm4v' ] .indexOf(ext) >= 0) {
				return classes['v']
			}

			if ([ 'jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg' ].indexOf(ext) >= 0) {
				return classes['i']
			}

			return classes['o']
		}

		this.getRecordsFormatted = (field, records) => {
			let data = []

			records = records || []
			for (let i in records) {
				let row = this.getItemForModel(field, records[i])

				data.push(row)
			}

			return data
		}

		this.callService = (field, params, baseServiceUrl, callback) => {
			if ((!field.pathService || field.pathService == '') || field.initialDisabled) {
				callback({ data: [] })

				return
			}

			let url = Array.isArray(field.pathService) ? field.pathService : ((baseServiceUrl) ? (baseServiceUrl + field.pathService) : [])

			if (Array.isArray(url)) {
				callback({ data: this.getRecordsFormatted(field, url) })
			} else if (field.pathService !== undefined && field.pathService !== null && field.pathService != '') {
				$http({
					method: 'GET', 
					url   : url,
					params: params,
				}).then((response) => {
					response.data.data = response.data.data || []

					if (response.data.data.length <= 0) {
						callback({ data: [] })

						return
					} else {
						callback({ data: this.getRecordsFormatted(field, response.data.data) })
					}
				}, () => {
					callback({ data: [] })

					return
				})
			} else {
				callback({ data: [] })

				return
			}
		}

		this.chunk = (a, n) => {
			a = a || []

			return [].concat.apply([], a.map((e, i) => {
				return i % n ? [] : [ a.slice(i, i + n) ]
			}))
		}

		this.alert = (msg) => {
			$mdDialog.show(
				$mdDialog.alert()
					.parent($('#content > .box'))
					.clickOutsideToClose(false)
					.title('Error')
					.textContent(msg)
					.ok('Aceptar'),
			)
		}

		this.timeToMinutesPerc = (item) => {
			const limit = '23:59'
			const totalMin = limit.split(':').map(a => parseInt(a || 0)).reduce((a, b) => (a * 60) + b)
			const startMin = item.from.split(':').map(a => parseInt(a || 0)).reduce((a, b) => (a * 60) + b)
			const endMin = item.to.split(':').map(b => parseInt(b || 0)).reduce((a, b) => (a * 60) + b)

			let _temp = {
				startMin : startMin,
				endMin   : endMin,
				startPerc: parseFloat(((startMin * 100) / totalMin).toFixed(2)),
				endPerc  : parseFloat(((endMin * 100) / totalMin).toFixed(2)),
				type     : item.type || 'booked',
				tooltip  : item.tooltip || 'BOOKING_BUSY',
			}

			return _temp
		}

		this.getPercentageArray = (marks) => {
			let finalArr = []

			for (let i in marks) {
				let last = finalArr.length - 1

				if (finalArr[last] && finalArr[last].type != 'free') {
					let start = finalArr[last].endPerc

					finalArr.push({
						type     : 'free',
						tooltip  : 'BOOKING_FREE', 
						perc     : marks[i].startPerc - start,
						endPerc  : marks[i].endPerc,
						startPerc: start,
						style    : {
							width: (marks[i].startPerc - start) + '%',
						},
					})
				}

				finalArr.push({
					type     : marks[i].type || 'booked',
					perc     : marks[i].endPerc - marks[i].startPerc,
					endPerc  : marks[i].endPerc, 
					startPerc: marks[i].startPerc,
					tooltip  : marks[i].tooltip || 'BOOKING_BUSY', 
					style    : {
						width: (marks[i].endPerc - marks[i].startPerc) + '%',
					},
				})
			}
			
			let totalPerc = finalArr.map(a => a.perc).reduce(((a, b) => (a + b)), 0)
			let last = finalArr.length - 1

			if (totalPerc < 100) {
				let width = finalArr[last] ? (finalArr[last].endPerc + 0.1) : 0

				finalArr.push({
					type     : 'free',
					tooltip  : 'BOOKING_FREE', 
					startPerc: 0,
					style    : {
						width: (100 - width) + '%',
					},
				})
			}

			return finalArr
		}

		this.getHoursList = (start, end, split, chrash) => {
			start = start || '00:00'
			end = end || '23:59'
			split = split || 30
			chrash = (chrash === undefined) ? false : chrash
			split = chrash ? (split - 1) : split
			const today = moment(new Date()).format('YYYY-MM-DD ')
			let i = moment(today + start)
			let f = moment(today + end)

			f.add((split * -1), 'minutes')
			let fin = moment(today + start)

			fin.add(split, 'minutes')
			let ID = 1
			let hours = [ { id: ID, start: start, end: fin.format('HH:mm') } ]

			while (parseInt(i.format('HHmmss')) < parseInt(f.format('HHmmss'))) {
				ID++
				i.add((chrash) ? split + 1 : split, 'minutes')
				fin = angular.copy(i)
				fin.add(split, 'minutes')

				if (fin.format('HHmmss') == '000000') {
					fin.add(-1, 'minutes')
				}

				hours.push({ id: ID, start: i.format('HH:mm'), end: fin.format('HH:mm') })
			}

			return hours
		}

		this.updateInputDataFromModel = (field) => {
			field = field || {}
			field.data = field.data || [ {} ]

			if (this.inputsInLine.indexOf(field.typefield) >= 0) {
				field.data[0] = field.data[0] || {}
				field.data[0].value = field.model
			}

			if (field.typefield == 'file') {
				field.data = angular.copy(field.filesModel)
			}

			return field
		}

		this.getOccurrenceTitle = (occurrence) => {
			occurrence.label = occurrence.label || ''
			let response = '<div class="occurrence-title">'
			let title = occurrence.label.split(' - ')

			if (title.length == 1) {
				return this.$translate(occurrence.label)
			}

			for (let i in title) {
				const conector = i > 0 ? '<span class="m-l-xs"> - </span>' : ''

				response += conector + ' <div class="m-l-xs">' + this.$translate(title[i]) + '</div>'
			}

			return response += '</div>'
		}

		this.getItemTitle = (item, code, name) => {
			item.label = item.label || ''
			let response = '<div class="occurrence-title">'
			const tcode = item[code] ? '<div class="m-l-xs">' + this.$translate(item[code]) + '</div>' : ''
			const tname = item[name] ? '<div class="m-l-xs">' + this.$translate(item[name]) + '</div>' : ''
			const conector = tcode && tname ? '<span class="m-l-xs"> - </span>' : ''

			return response + tcode + conector + tname + '</div>'
		}

		this.getFormattedStudentName = (student) => {
			student = student || {}
			this.systemConfig.studentNameFormat = this.systemConfig.studentNameFormat || this.systemConfig.teacherNameFormat || ':firstName :lastName'
			let displayName = this.systemConfig.studentNameFormat.replaceAll(':firstName', (student.studentFirstName || student.nameStudent))

			displayName = displayName.replaceAll(':lastName', (student.studentLastName || student.lastName))

			return displayName
		}

		this.getReportColums = () => {
			let response = {
				//lista para isil, se debe cambiar clientName
				isil: [					
					{
						ds_origin: 'Campus', new_name : this.$translate('CAMPUS'),
					}, {
						ds_origin: 'Id_Periodo_Academico', new_name : this.$translate('ACADEMIC_PERIOD_ID'),
					}, {
						ds_origin: 'turno', new_name : this.$translate('TURN'),
					}, {
						ds_origin: 'Id_Curso', new_name : this.$translate('COURSE') + '_Id',
					}, {
						ds_origin: 'Descripcion_del_Curso',	new_name : this.$translate('COURSE_DESCRIPTION'),
					}, {
						ds_origin: 'Id_Actividad', new_name : this.$translate('ACTIVITY_ID'),
					}, {
						ds_origin: 'id_uplanner', new_name : this.$translate('ID_UPL'),
					}, {
						ds_origin: 'id_padre', new_name : this.$translate('ID_FATHER'),
					}, {
						ds_origin: 'Capacidad_Inscripcion', new_name : this.$translate('INSCRIPTION_CAPACITY'), // sss.nm_sectionQuota AS estudiantes_seccion
					}, {
						ds_origin: 'Id_Plan', new_name : this.$translate('PENSUM_ID'),
					}, {
						ds_origin: 'ds_studentsCohort',	new_name : this.$translate('DS_COHORTE'),
					}, {
						ds_origin: 'Numero_Inscritos', new_name : this.$translate('N_ENROLLED'), //?ssf.nm_students AS estudiantes_grupo_compatible
					}, {
						ds_origin: 'Grupo', new_name : this.$translate('GROUPS'),
					}, {
						ds_origin: 'nota_de_clase', new_name : this.$translate('MENU_CLASS_NOTE'),
					}, {
						ds_origin: 'modulo', new_name : this.$translate('MODULE'),
					}, {
						ds_origin: 'dia', new_name : this.$translate('DAY'),
					}, {
						ds_origin: 'Docente', new_name : this.$translate('TEACHER'),
					}, {
						ds_origin: 'Edificio_Salon', new_name : this.$translate('BUILDING_ROOMS'),
					}, {
						ds_origin: 'id_simulation', new_name : this.$translate('SIMULATION'),
					},
				],
				uplanner: [					
					{
						ds_origin: 'Campus', new_name : this.$translate('CAMPUS'),
					}, {
						ds_origin: 'Capacidad',	new_name : this.$translate('CAPACITY'),
					}, {
						ds_origin: 'Capacidad_Inscripcion', new_name : this.$translate('INSCRIPTION_CAPACITY'),
					}, {
						ds_origin: 'capacidad_ociosa', new_name : this.$translate('IDLE_CAPACITY'),
					}, {
						ds_origin: 'Cargo_Docente', new_name : this.$translate('TEACHER_ROLE'),
					}, {
						ds_origin: 'Carrera', new_name : this.$translate('CAREER'),
					}, {
						ds_origin: 'Ciclo', new_name : this.$translate('CYCLE'),
					}, {
						ds_origin: 'Cohorte', new_name : this.$translate('COHORTE'),
					}, {
						ds_origin: 'Descripcion_del_Curso',	new_name : this.$translate('COURSE_DESCRIPTION'),
					}, {
						ds_origin: 'Docente', new_name : this.$translate('TEACHER'),
					}, {
						ds_origin: 'ds_studentsCohort',	new_name : this.$translate('YEAR_OF_ENTRY'),
					}, {
						ds_origin: 'Edificio_Salon', new_name : this.$translate('BUILDING_ROOMS'),
					}, {
						ds_origin: 'Estado', new_name : this.$translate('STATUS'),
					}, {
						ds_origin: 'Evaluacion_Docente', new_name : this.$translate('TEACHER_EVALUATION'),
					}, {
						ds_origin: 'Fecha_Fin', new_name : this.$translate('END_DATE'),
					}, {
						ds_origin: 'Fecha_Inicio', new_name : this.$translate('START_DATE'),
					}, {
						ds_origin: 'Frecuencia', new_name : this.$translate('IMPROVE_FRECUENCY'),
					}, {
						ds_origin: 'Grupo', new_name : this.$translate('GROUPS'),
					}, {
						ds_origin: 'Grupo_Unico', new_name : this.$translate('UNIQUE_GROUP'),
					}, {
						ds_origin: 'grupos_compactados', new_name : this.$translate('COMPACTED_GROUPS'),
					}, {
						ds_origin: 'Horario_Fin', new_name : this.$translate('END_TIME'),
					}, {
						ds_origin: 'Horario_Inicio', new_name : this.$translate('START_TIME'),
					}, {
						ds_origin: 'Horas_Utilizadas_Semanales', new_name : this.$translate('HOURS_USED_PER_WEEK'),
					}, {
						ds_origin: 'Id_Actividad', new_name : this.$translate('ACTIVITY_ID'),
					}, {
						ds_origin: 'Id_Campus', new_name : this.$translate('CAMPUS') + '_Id',
					}, {
						ds_origin: 'Id_Carrera', new_name : this.$translate('CAREER') + '_Id',
					}, {
						ds_origin: 'Id_Curso', new_name : this.$translate('COURSE') + '_Id',
					}, {
						ds_origin: 'Id_Docente', new_name : this.$translate('TEACHER_ID'),
					}, {
						ds_origin: 'id_padre', new_name : this.$translate('ID_FATHER'),
					}, {
						ds_origin: 'id_pensum', new_name : this.$translate('PENSUM_ID'),
					}, {
						ds_origin: 'Id_Periodo_Academico', new_name : this.$translate('ACADEMIC_PERIOD_ID'),
					}, {
						ds_origin: 'Id_Plan', new_name : this.$translate('PENSUM_ID '),
					}, {
						ds_origin: 'id_uplanner', new_name : this.$translate('ID_UPL'),
					}, {
						ds_origin: 'Maximas_Horas_Semanales', new_name : this.$translate('MAX_WEEKLY_HOURS'),
					}, {
						ds_origin: 'Modalidad_Temporalidad', new_name : this.$translate('MODALITY_TEMPORALITY'),
					}, {
						ds_origin: 'Nivel', new_name : this.$translate('LEVEL'),
					}, {
						ds_origin: 'nm_usedQuota', new_name : this.$translate('QUOTA'),
					}, {
						ds_origin: 'nota_de_clase', new_name : this.$translate('MENU_CLASS_NOTE'),
					}, {
						ds_origin: 'Numero_Horas_Total_Semana', new_name : this.$translate('WEEKLY_BLOCKS'),
					}, {
						ds_origin: 'Numero_Inscritos', new_name : this.$translate('N_ENROLLED'),
					}, {
						ds_origin: 'Plan_Academico', new_name : this.$translate('ACADEMIC_PLAN'),
					}, {
						ds_origin: 'Porcentaje_capacidad_Ocupada', new_name : this.$translate('PERCENTAGE_OCCUPIED_CAPACITY'),
					}, {
						ds_origin: 'Sesion', new_name : this.$translate('SESSION'),
					}, {
						ds_origin: 'Tipo_Uso_Detallado', new_name : this.$translate('USAGE_TYPE_DETAILED'),
					}, {
						ds_origin: 'turno', new_name : this.$translate('TURN'),
					},
				], 
				uin: [					
					{
						ds_origin: 'Campus', new_name : 'Plantel_Licenciatura',	
					}, {
						ds_origin: 'Descripcion_del_Curso', new_name : 'Asignatura',
					}, {
						ds_origin: 'Cohorte', new_name : 'Año Academico',
					}, {
						ds_origin: 'Periodo', new_name : 'Periodo',
					}, {
						ds_origin: 'Clave Power Campus', new_name : 'Clave Power Campus',
					}, {
						ds_origin: 'seccion', new_name : 'seccion',
					}, {
						ds_origin: 'Nro Estudiantes', new_name : 'Nro Estudiantes',
					}, {
						ds_origin: 'Horas del plan', new_name : 'Horas del plan',
					}, {
						ds_origin: 'Horas_por_Semana', new_name : 'Horas_por_Semana',
					}, {
						ds_origin: 'Fecha Inicial', new_name : 'Fecha Inicial',
					}, {
						ds_origin: 'Fecha Final', new_name : 'Fecha Final',
					}, {
						ds_origin: 'Programa', new_name : 'Programa',
					}, {
						ds_origin: 'Nivel Clase', new_name : 'Nivel Clase',
					}, {
						ds_origin: 'Tipo_operacion', new_name : 'Tipo_operacion',
					}, {
						ds_origin: 'Dias', new_name : 'Dias',
					}, {
						ds_origin: 'Horario Inicio', new_name : 'Horario Inicio',
					}, {
						ds_origin: 'Horario Fin', new_name : 'Horario Fin',
					}, {
						ds_origin: 'Turno x grupo', new_name : 'Turno x grupo',
					}, {
						ds_origin: 'Docente', new_name : this.$translate('TEACHER'),
					}, {		
						ds_origin: 'Edificio', new_name : 'Edificio',
					}, {
						ds_origin: 'Salon', new_name : 'Salon',
					}, {
						ds_origin: 'Instalaciones', new_name : 'Instalaciones',
					}, {
						ds_origin: 'Observaciones', new_name : 'Observaciones',
					},
				],
			}

			return response[this.systemConfig.clientName]
		}

		this.validateUniqueFieldOnEvaluationStructure = (input, nodes, alreadyUsed) => {
			nodes = nodes || []
			this.alreadyUsed = alreadyUsed || []
			const isValid = (input, node) => {
				for (let field of node.headerInputs) {
					if (input.label == field.label) {
						if (this.inputsInLine.indexOf(field.typefield) >= 0) {
							if (this.alreadyUsed.indexOf(field.model) >= 0) {
								return false
							} else {
								this.alreadyUsed.push(field.model)
								break
							}
						} else if (this.inputsObject.indexOf(field.typefield) >= 0) {
							if (this.alreadyUsed.indexOf(field.model[field.config.id] >= 0)) {
								return false
							} else {
								this.alreadyUsed.push(field.model[field.config.id])
								break
							}
						} else {
							return true
						}
					}
				}

				if (node.nodes.length) {
					return this.validateUniqueFieldOnEvaluationStructure(input, node.nodes, this.alreadyUsed)
				}

				return true
			}

			for (let node of nodes) {
				if (!isValid(input, node)) {
					return false
				}
			}

			return true
		}

		this.findEvaluationStructure = (structure) => {
			structure = structure || []
			let found = false

			for (let element of structure) {
				if (Array.isArray(element)) {
					for (let i in element) {
						if (element[i].typefield == 'structure') {
							return angular.copy(element[i].data)
						} else if (this.inputs.indexOf(element[i].typefield) < 0) {
							found = this.findEvaluationStructure(element[i].data)

							if (found) {
								return found
							}
						}
					}
				} else {
					if (element.typefield == 'structure') {
						return angular.copy(element.data)
					} else if (this.inputs.indexOf(element.typefield) < 0) {
						found = this.findEvaluationStructure(element.data)

						if (found) {
							return found
						}
					}
				}
			}

			return found
		}

		this.download = (url, filename, callback, method) => {
			if (url) {
				callback = callback || (() => {})
				const token = $cookies.get('token')
				const request = {
					method      : method || 'GET',
					url         : url,
					responseType: 'blob',
					headers     : { 'x-access-token': token },
				}

				$http(request)
					.then((response) => {
						let a = document.createElement('a')

						if (response.data.type == 'application/json') {
							callback(false, [])
							
							ngNotify.set(':::Ocurrio un error al intentar descargar el archivo', 'error')

							return false
						}

						a.href = window.URL.createObjectURL(response.data)
						a.download = filename
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						callback(true)
					}, (error) => {
						callback(false, error)
						// eslint-disable-next-line no-console
						console.log('error->', error)
						ngNotify.set(':::Ocurrio un error al intentar descargar el archivo', 'error')
					})
			}
		}

		this.base64 = data => new Buffer(data).toString('base64')

		this.getUserStored = (data) => {
			data = data || this.$localStorage.userAuth

			if (data) {
				return JSON.parse(decodeURIComponent(atob(data)
					.split('')
					.map((c) => ('%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)))
					.join('')))
			} else {
				return false
			}
		}

		this.getShortName = (name = '') => {
			const names = name.split(' ')

			if (names.length == 1) {
				return names[0].substring(0, 3)
			} else if (names.length > 1) {
				return names.reduce((b, c, i) => (b.substring(0, i) + c[0]))
			}

			return name
		}

		this.cacheServiceFlush = (bucket) => {
			lscache.setBucket(bucket)
			lscache.flush()
		}

		this.cacheServiceRemove = (key) => lscache.remove(key)
		
		this.cacheService = (options) => {
			const {
				params = {}, 
				service, 
				storage, 
				time = 120, 
				delay = 300, 
				bucket,
			} = options

			lscache.setBucket(bucket)

			const key = `${$.param(params)}-${storage}`
			const data = lscache.get(key)
			
			if (data) 
				return new Promise((resolve) => $timeout(() => resolve(data), delay))

			return service(params).$promise.then((response) => {
				if (response.status) {
					response.key = key
					lscache.set(key, response, time)
				}

				return response
			})
		}

		return {
			checkStructureInputsRequire             : this.checkStructureInputsRequire,
			getParam                                : this.getParam,
			chunkData                               : this.chunkData,
			defineStructure                         : this.defineStructure,
			definePanel                             : this.definePanel,
			getItemForModel                         : this.getItemForModel,
			organizeElements                        : this.organizeElements,
			saveChanges                             : this.saveChanges,
			validateRequiredInputs                  : this.validateRequiredInputs,
			getListByConcept                        : this.getListByConcept,
			consoleLog                              : this.consoleLog, 
			checkCode                               : this.checkCode, 
			guid                                    : this.guid, 
			getGridConfig                           : this.getGridConfig, 
			getFieldData                            : this.getFieldData, 
			findFunction                            : this.findFunction, 
			// mathjs                                  : this.mathjs, 
			getRandomClassColor                     : this.getRandomClassColor, 
			getHeaderCellTemplate                   : this.getHeaderCellTemplate, 
			getTitle                                : this.getTitle, 
			getWeekDays                             : this.getWeekDays, 
			prepareCourseList                       : this.prepareCourseList, 
			prepareSectionList                      : this.prepareSectionList, 
			filterInObject                          : this.filterInObject,
			getFileIcon                             : this.getFileIcon,
			callService                             : this.callService,
			chunk                                   : this.chunk,
			alert                                   : this.alert,
			timeToMinutesPerc                       : this.timeToMinutesPerc,
			getPercentageArray                      : this.getPercentageArray,
			getHoursList                            : this.getHoursList,
			updateInputDataFromModel                : this.updateInputDataFromModel,
			getOccurrenceTitle                      : this.getOccurrenceTitle,
			getItemTitle                            : this.getItemTitle,
			getFormattedStudentName                 : this.getFormattedStudentName,
			getReportColums                         : this.getReportColums,
			validateUniqueFieldOnEvaluationStructure: this.validateUniqueFieldOnEvaluationStructure,
			findEvaluationStructure                 : this.findEvaluationStructure,
			download                                : this.download,
			getUserStored                           : this.getUserStored,
			getShortName                            : this.getShortName,
			cacheService                            : this.cacheService,
			cacheServiceFlush                       : this.cacheServiceFlush,
			base64                                  : this.base64,
		}
	}

}

Helpers.$inject = [ 'SERVICE_URL_CONSTANT', '$filter', '$http', 'ngNotify', '$mdDialog', 'LOCAL_ENV_CONSTANT', '$cookies', '$localStorage', 'moment', '$timeout' ]

export default angular.module('services.Helpers', [])
	.service('Helpers', Helpers)
	.name



// WEBPACK FOOTER //
// ./src/helpers/index.js